module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbx_invo"
  }, [_c('div', {
    staticStyle: {
      "overflow-y": "auto"
    },
    style: ({
      height: (_vm.pullHeight - 51) + 'px'
    })
  }, [_c('group', {
    attrs: {
      "gutter": "0.77em"
    }
  }, [_c('cell', {
    attrs: {
      "title": "名称"
    }
  }, [_c('div', {
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [_c('span', {}, [_vm._v(_vm._s(_vm.fpDetail.name))])])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "类型"
    }
  }, [_c('div', {
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [(_vm.fpDetail.type === 0) ? _c('span', {}, [_vm._v("个人")]) : _vm._e(), _vm._v(" "), (_vm.fpDetail.type === 1) ? _c('span', {}, [_vm._v("单位")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tu"
  }, [_c('img', {
    attrs: {
      "src": 'data:image/png;base64,' + _vm.fpDetail.cardImg
    }
  }), _vm._v(" "), _c('p', [_vm._v("商家扫描二维码快速获取发票抬头信息")])])], 1), _vm._v(" "), (_vm.showEdit) ? _c('div', {
    staticClass: "queding"
  }, [_c('x-button', {
    staticClass: "btn-new-sty",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick('/addFinish1/' + _vm.fpDetail.id)
      }
    }
  }, [_vm._v("编辑")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ef8386c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/viewCard.vue
// module id = 343
// module chunks = 0